import { render, staticRenderFns } from "./ArchivedTripSection.vue?vue&type=template&id=6b55489e&scoped=true&"
import script from "./ArchivedTripSection.vue?vue&type=script&lang=ts&"
export * from "./ArchivedTripSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b55489e",
  null
  
)

export default component.exports